import { Suspense, lazy } from 'react';
import { RouteProps } from 'react-router-dom';

import { TPermissions, TUserRoles } from '@cloud-wave/neon-common-lib';

import { anyValidUser } from '../../routes/userRoleCombinations';
import { TConnectPermissions, TPermissionTypes } from '../types/Permissions';
import Loader from './Loader';
import RequiresPermission from './RequiresPermission/RequiresPermission';

const NotFound = lazy(() => import('lib/common/components/NotFound'));

type AuthorisedRouteProps = {
  permission?: TPermissions | TConnectPermissions;
  permissionType?: TPermissionTypes;
  allowedRoles?: TUserRoles[];
} & RouteProps;

export default function AuthorisedRoute({
  permission,
  permissionType,
  children,
  allowedRoles = anyValidUser,
}: AuthorisedRouteProps) {
  return (
    <RequiresPermission
      permission={permission}
      permissionType={permissionType}
      fallback={
        <Suspense fallback={<Loader centered />}>
          <NotFound />
        </Suspense>
      }
      allowedRoles={allowedRoles}
    >
      {children}
    </RequiresPermission>
  );
}
